import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams,useLocation } from "react-router-dom";
import CoachLayout from "../common/CoachLayout";
import { CoachHeader } from "../common/CoachHeader";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import API_URL from "../../api/API";

export const CoachStaticStrengthWorkout = () => {
  const navigate = useNavigate();
  const { coach } = useCoachAuthContext();
  const location = useLocation();
    // Access templates data passed via location.state
    const templates = location.state?.templates;


  const { template_id } = useParams();

  const [openIndex, setOpenIndex] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [weeks, setWeeks] = useState([]);
  const [dayOpenIndex, setDayOpenIndex] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchWorkoutData = async () => {
      try {
        setLoading(true);
        const response = await fetch(API_URL.GET_COACH_STATIC_STRENGTH_WORKOUT_WEEKS_DAYS + template_id, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${coach.token}`,
            'Content-Type': 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error("Failed to fetch workout data");
        }
        const data = await response.json();
        setWeeks(data.workouts);
      } catch (error) {
        console.error("Error fetching workout data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchWorkoutData();
  }, [coach.token]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const toggleDayAccordion = (weekIndex, dayIndex) => {
    setDayOpenIndex((prevState) => ({
      ...prevState,
      [`${weekIndex}-${dayIndex}`]: !prevState[`${weekIndex}-${dayIndex}`]
    }));
  };

  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

    // Handle back button click and pass templates state back
    const handleBackClick = () => {
      navigate('/coach/static-strength-workout/templates',{ state: { templates } }); // Pass templates back on go back
    };
  

  return (
    <CoachLayout>
      <div className="bg-white">
        <CoachHeader />
      </div>

    

      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">{formatDate(selectedDate)}</p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="w-full max-w-2xl mx-auto h-full bg-black">
        <div className="text-white py-3 bg-black">

        <div className="w-full text-center relative py-4">
            <span
              className="absolute left-5 top-1/2 -translate-y-1/2 flex items-center gap-2 cursor-pointer text-white hover:text-gray-300"
              onClick={handleBackClick}
            >
              <BackArrow /> Back
            </span>
          </div>

          {loading ? (
            <p className="text-white text-center">Loading Workouts...</p>
          ) : error ? (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">{error}</div>
          ) : (
          <div className="space-y-[15px] overflow-hidden overflow-y-auto px-5">
            {weeks.map((week, weekIndex) => (
              <div key={weekIndex} className={`${openIndex === weekIndex && "!border-0 bg-[#242424]"} py-[15px] px-5 border-b border-white/20`}>
                <button
                  className="w-full flex justify-between items-center gap-5 text-white text-base font-normal"
                  onClick={() => toggleAccordion(weekIndex)}
                >
                  <p>{week.week}</p>
                  <span
                    className={`transform transition-transform ${openIndex === weekIndex ? "rotate-180" : ""}`}
                  >
                    <ArrowD />
                  </span>
                </button>
                {openIndex === weekIndex && (
                  <div className="p-[0px_0px_0px_15px]">
                    {week.days.map((day, dayIndex) => (
                      <div key={dayIndex}>
                        <div
                          className="p-[15px_0px] flex justify-between items-center border-b border-white/20 last:border-b-0"
                          onClick={() => toggleDayAccordion(weekIndex, dayIndex)}
                        >
                          <p>{day.day}</p>
                          <span
                            className={`transform transition-transform ${dayOpenIndex[`${weekIndex}-${dayIndex}`] ? "rotate-180" : ""}`}
                          >
                            <ArrowD />
                          </span>
                        </div>
                        {dayOpenIndex[`${weekIndex}-${dayIndex}`] && (
                          <div className="pl-4">
                            <p className="py-1 text-sm text-white">
                              <Link to={`/coach/static-strength-workout/day/${day.id}`}>View {day.day} Workout</Link>
                            </p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
          )}
        </div>
      </div>
    </CoachLayout>
  );
};

const BackArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="white"
        d="M15 19l-7-7 7-7"
      />
    </svg>
  );
};

const ArrowG = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path d="M1 13L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowL = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 rotate-180 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path d="M1 13L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const ArrowD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path d="M13 1L7 7L1 1" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
